import Spine from 'core/display/Spine'

export default class SpineSymbol extends Spine {
  constructor(data) {
    super(data)
    this.x = (data.width / 4)
    this.y = (data.height / 4)
    if (data.skin){
      this.skeleton.setSkinByName(data.skin)
      this.skeleton.setToSetupPose()
    }

  }
}
